import {
  handleApiGet,
  handleApiPost,
  handleApiDeletePicture,
  handleApiPut,
  definedRouteTypes,
} from "./api";
import { IBaseForm, EntityForm } from "./index.d";
import { BackendUrl } from "./newBackendApi";

// The backend rejects bodies that contain these fields
const READ_ONLY_FIELDS = [
  "createdAt",
  "updatedAt",
  "created",
  "modified",
  "id",
  "author",
  "creator",
  "creatorId",
  "creatorName",
  "creatorImage",
  "entity",
  "mediaSourceInfo",
  "homepageRank",
  "imagePointer",
  "imageThumbnailUrl",
  "hasTemplateSite",
  "url",
];

const BUSINESS_TYPES: string[] = [
  definedRouteTypes.organizations,
  definedRouteTypes.companies,
  definedRouteTypes.selfEmployed,
];

function toAdminBody(body: Record<string, any>) {
  const adminBody = { ...body };
  READ_ONLY_FIELDS.forEach((field) => delete adminBody[field]);

  // The backend sets author on business items, and their schema rejects it
  if (BUSINESS_TYPES.includes(adminBody.type)) delete adminBody.author;

  // The schema expects 1 / 0, but get-item returns "1" / "0" and form toggles set booleans
  ["show", "displayInHomePage"].forEach((flag) => {
    if (adminBody[flag] !== undefined) {
      adminBody[flag] = Number(adminBody[flag]);
    }
  });

  // The schema declares these as URIs, so an empty string is invalid
  ["imageUrl", "mediaLink"].forEach((field) => {
    if (!adminBody[field]) delete adminBody[field];
  });

  // The schema allows null but not an empty string. Null also clears the field on update.
  ["category", "organizationId", "region"].forEach((field) => {
    if (adminBody[field] === "") adminBody[field] = null;
  });

  // Empty inputs leave "" in these lists, which the schema rejects
  ["email", "phone"].forEach((field) => {
    if (adminBody[field]) adminBody[field] = adminBody[field].filter(Boolean);
  });

  return adminBody;
}

export function getSingleData(type: string, slug: string) {
  return handleApiGet(
    `${BackendUrl}/get-item/${encodeURIComponent(type)}/${encodeURIComponent(
      slug,
    )}`,
  );
}

// TODO: Fix (body:any) @Dainis
export function postData(idToken: string, type: string, body: any) {
  return handleApiPost(
    `${BackendUrl}/admin/create/${encodeURIComponent(type)}`,
    idToken,
    toAdminBody(body),
  );
}

export function deleteData(idToken: string, type: string, slug: string) {
  return handleApiDeletePicture(
    `${BackendUrl}/admin/delete/${encodeURIComponent(
      type,
    )}?slug=${encodeURIComponent(slug)}`,
    idToken,
    {},
  );
}

export function updateData(
  idToken: string,
  type: string,
  body: Partial<IBaseForm | EntityForm>,
) {
  return handleApiPut(
    `${BackendUrl}/admin/update/${encodeURIComponent(type)}`,
    idToken,
    toAdminBody(body),
  );
}
